import React from "react";
import BreadCrumb from "common/breadcrumb";
import Contacts from "./contacts";
import ContactsForm from "./contacts-form";

const ContactUs = () => {
    return (
        <React.Fragment>
            <BreadCrumb title="Contact Us" pageTitle='Pages' />
            <Contacts />
            <ContactsForm />
        </React.Fragment>

    );
}

export default ContactUs;